import React, { useState, useEffect } from 'react'
import { useTheme } from '@mui/material/styles'
import { Box, Avatar, Typography } from '@mui/material'
import MyStethiAIIcon from '/src/components/Icons/MyStethiAIIcon'

const statusMessages = [
  'Reviewing the job board...',
  'Scrubbing in...',
  'Cross-referencing specialties...',
  'Making the rounds...',
  'Checking credentials...',
  'Paging the right departments...',
  'Consulting the charts...',
  'Prepping your results...',
]

const TypingIndicator = () => {
  const theme = useTheme()
  const [messageIndex, setMessageIndex] = useState(0)
  const [opacity, setOpacity] = useState(1)

  useEffect(() => {
    const interval = setInterval(() => {
      setOpacity(0)
      setTimeout(() => {
        setMessageIndex((previous) => (previous + 1) % statusMessages.length)
        setOpacity(1)
      }, 300)
    }, 3500)

    return () => clearInterval(interval)
  }, [])

  return (
    <Box
      sx={{
        display: 'flex',
        gap: 1.5,
        alignItems: 'flex-start',
      }}
    >
      <Avatar
        sx={{
          backgroundColor: theme.palette.ai.main,
          width: 32,
          height: 32,
          animation: 'heartbeat 1.5s ease-in-out infinite',
          '@keyframes heartbeat': {
            '0%':   { transform: 'scale(1)' },
            '14%':  { transform: 'scale(1.15)' },
            '28%':  { transform: 'scale(1)' },
            '42%':  { transform: 'scale(1.1)' },
            '56%':  { transform: 'scale(1)' },
            '100%': { transform: 'scale(1)' },
          },
        }}
      >
        <MyStethiAIIcon
          sx={{
            color: theme.palette.common.white,
            fontSize: '1.1rem',
          }}
        />
      </Avatar>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          p: 1.5,
          bgcolor: theme.palette.grey[100],
          borderRadius: 2,
          minWidth: 180,
        }}
      >
        <Typography
          variant="body2"
          sx={{
            color: theme.palette.text.secondary,
            fontStyle: 'italic',
            opacity: opacity,
            transition: 'opacity 0.3s ease',
          }}
        >
          {statusMessages[messageIndex]}
        </Typography>
      </Box>
    </Box>
  )
}

export default TypingIndicator
